import React from 'react';

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const handleHello = () => {
    const botMessage = createChatBotMessage('Hello. Nice to meet you.');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  const handleBye = () => {
    const botMessage = createChatBotMessage('Thank you for chat with me!');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  const handleReservation = () => {
    const botMessage = createChatBotMessage('You can book directly through our website by clicking on the “Book Now” button. You can also contact us via phone or email for assistance.');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  const handlePayAdvance = () => {
    const botMessage = createChatBotMessage('Yes, a payment in advance is usually required to confirm your reservation. Please check the payment policy for more details.');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  const handleCheckInOutTime = () => {
    const botMessage = createChatBotMessage('Check-in time is from 2:00 PM and check-out is until 11:00 AM. Let us know if you need early check-in or late check-out!');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  const handleEarlyLateCheck = () => {
    const botMessage = createChatBotMessage('Early check-in and late check-out are subject to availability. Please contact the front desk or mention it while booking to request these options.');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  const handleTransportInfo = () => {
    const botMessage = createChatBotMessage(`You can reach the hostel by taxi, ride-sharing apps, or public transport. From the airport, it's about 30 minutes by cab. From the train station, it's around 15 minutes. Let us know if you need a pickup!`);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  const handleUnknown = () => {
    const botMessage = createChatBotMessage(`Please contact us at info@dredugroup.com`);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  const handleShowQuestions = () => {
    const message = createChatBotMessage("Select a question:", {
      widget: "faqOptions",
    });
    updateChatbotState(message);
  };

  const handleShowAnswer = (answer) => {
    const message = createChatBotMessage("Here's the answer:", {
      widget: "showAnswer",
      payload: { answer },
    });
    updateChatbotState(message);
  };

  const updateChatbotState = (message) => {
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, message],
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            handleHello,
            handleBye,
            handleReservation,
            handlePayAdvance,
            handleCheckInOutTime,
            handleEarlyLateCheck,
            handleTransportInfo,
            handleShowQuestions,
            handleShowAnswer,

            handleUnknown
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;